// React import removed
import { Routes, Route } from 'react-router-dom'
import CoordinatorLayout from './CoordinatorLayout'
import CoordinatorOverview from './CoordinatorOverview'
import ChurchRegistration from './ChurchRegistration'
import ParticipantManagement from './ParticipantManagement'

const CoordinatorDashboard: React.FC = () => {
  return (
    <CoordinatorLayout>
      <Routes>
        <Route index element={<CoordinatorOverview />} />
        <Route path="church-registration" element={<ChurchRegistration />} />
        <Route path="participants" element={<ParticipantManagement />} />
      </Routes>
    </CoordinatorLayout>
  )
}

export default CoordinatorDashboard